module.exports = __webpack_public_path__ + "img/booster2.d6dd4744.png";